import React, { useCallback, useEffect, useState } from 'react';
const names = ['Cecilia H.', 'Martín G.', 'Laura P.', 'Diego R.', 'Ana M.', 'Carlos S.', 'Lucía F.', 'Pablo T.'];
const cities = ['San Luis', 'Córdoba', 'Rosario', 'Mendoza', 'CABA', 'Tucumán', 'Salta', 'Neuquén'];
const products = ['Pack Completo Física + Química', 'Pack Completo Física + Química', 'Física Lista', 'Química Lista'];
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchaseNotification() {
  const [notification, setNotification] = useState<{
    name: string;
    city: string;
    product: string;
    time: string;
  } | null>(null);
  const show = useCallback(() => {
    setNotification({
      name: randomItem(names),
      city: randomItem(cities),
      product: randomItem(products),
      time: String(Math.floor(Math.random() * 15) + 2)
    });
    setTimeout(() => {
      setNotification(null);
      setTimeout(show, Math.floor(Math.random() * 25000) + 25000);
    }, 4000);
  }, []);
  useEffect(() => {
    // Delay first notification significantly to not interfere with initial load
    const t = setTimeout(show, 15000);
    return () => clearTimeout(t);
  }, [show]);
  if (!notification) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-brand-card rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)] border border-brand-border p-3 max-w-[260px] pointer-events-none" data-id="element-239">
      <div className="flex items-start gap-3" data-id="element-240">
        <span className="text-brand-accent text-sm mt-0.5" data-id="element-241">✅</span>
        <div data-id="element-242">
          <div className="text-[10px] font-bold text-brand-accent uppercase tracking-widest mb-1" data-id="element-243">
            Compra verificada
          </div>
          <div className="text-xs text-white leading-tight mb-0.5" data-id="element-244">
            <span className="font-bold" data-id="element-245">{notification.name}</span> de{' '}
            {notification.city}
          </div>
          <div className="text-[11px] text-white/70 leading-tight mb-1.5" data-id="element-246">
            compró{' '}
            <span className="font-bold text-white" data-id="element-247">{notification.product}</span>{' '}
            🔬
          </div>
          <div className="text-[10px] text-white/60 italic font-medium" data-id="element-248">
            hace {notification.time} minutos
          </div>
        </div>
      </div>
    </div>;
}